var _defs, _circle, _path, _path2, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10141",
    "data-name": "Caminho 10141",
    d: "M684.021,328.1l48.22,29.107,45.469-27.387v-42.4h-89.9Z",
    transform: "translate(-684.021 -287.422)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12657",
    "data-name": "Grupo 12657",
    transform: "translate(-78 -153)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_58",
    "data-name": "Elipse 58",
    cx: 110,
    cy: 110,
    r: 110,
    transform: "translate(78 153)",
    fill: "#ddd",
    opacity: 0.143
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12638",
    "data-name": "Grupo 12638",
    transform: "translate(-1281.099 411.444)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10112",
    "data-name": "Caminho 10112",
    d: "M633.914,724.719v53.37c0,3.927,3.45,7.111,7.7,7.111h89.618c4.255,0,7.7-3.184,7.7-7.111v-53.37Z",
    transform: "translate(782.171 -884.381)",
    fill: "#f2cb30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10113",
    "data-name": "Caminho 10113",
    d: "M711.594,386.88,688.815,373.1a6.706,6.706,0,0,0-7.064,0l-22.779,13.779L632.66,402.792l26.311,15.876,26.311,15.876,26.311-15.894,26.311-15.859Z",
    transform: "translate(783.316 -562.433)",
    fill: "#eab531"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12621",
    "data-name": "Grupo 12621",
    transform: "translate(1417.959 -138.777)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12619",
    "data-name": "Grupo 12619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10114",
    "data-name": "Caminho 10114",
    d: "M655.631,1002.058a.184.184,0,0,1-.138-.307L688.31,964.83a.184.184,0,0,1,.276.245L655.769,1002A.184.184,0,0,1,655.631,1002.058Z",
    transform: "translate(-655.447 -964.768)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12620",
    "data-name": "Grupo 12620",
    transform: "translate(68.096 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10115",
    "data-name": "Caminho 10115",
    d: "M1471.13,1002.058a.183.183,0,0,1-.138-.062l-32.817-36.921a.184.184,0,0,1,.276-.245l32.816,36.921a.184.184,0,0,1-.138.307Z",
    transform: "translate(-1438.129 -964.768)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12637",
    "data-name": "Grupo 12637",
    transform: "translate(1420.445 -197.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12636",
    "data-name": "Grupo 12636",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12635",
    "data-name": "Grupo 12635",
    transform: "translate(4.938 12.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12633",
    "data-name": "Grupo 12633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10138",
    "data-name": "Caminho 10138",
    d: "M816.666,427.878H743.15a2.431,2.431,0,0,0-2.37,2.421v59.66h86.432V438.591Z",
    transform: "translate(-740.78 -427.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10139",
    "data-name": "Caminho 10139",
    d: "M1623.728,439.363l-9.647.083a.854.854,0,0,1-.637-.277.9.9,0,0,1-.2-.681v-9.764Z",
    transform: "translate(-1537.337 -428.65)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12634",
    "data-name": "Grupo 12634",
    transform: "translate(30.018 12.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10140",
    "data-name": "Caminho 10140",
    d: "M1044.541,566.46a11.767,11.767,0,0,1-.743,4.259,7.055,7.055,0,0,1-2.1,3.031,4.862,4.862,0,0,1-3.152,1.1,3.922,3.922,0,0,1-2.118-.574,3.293,3.293,0,0,1-1.326-1.511h-.259a5.544,5.544,0,0,1-4.445,2.085,5.95,5.95,0,0,1-4.51-1.721,6.53,6.53,0,0,1-1.649-4.712,7.28,7.28,0,0,1,2.166-5.5,7.816,7.816,0,0,1,5.657-2.085,19.583,19.583,0,0,1,3.063.267,16.847,16.847,0,0,1,2.756.639l-.372,7.9q0,2.247,1.229,2.247,1.035,0,1.649-1.511a10.653,10.653,0,0,0,.614-3.952,9.492,9.492,0,0,0-1.083-4.6,7.35,7.35,0,0,0-3.047-3.047,9.361,9.361,0,0,0-4.486-1.051,11.474,11.474,0,0,0-5.674,1.342,8.969,8.969,0,0,0-3.694,3.871,12.732,12.732,0,0,0-1.285,5.843q0,4.461,2.384,6.846t6.91,2.384a20.82,20.82,0,0,0,3.766-.38,24.964,24.964,0,0,0,4.041-1.107v3.1a19.428,19.428,0,0,1-7.678,1.471q-6.143,0-9.577-3.233t-3.435-8.987a15.044,15.044,0,0,1,1.754-7.25,12.726,12.726,0,0,1,4.995-5.108,14.776,14.776,0,0,1,7.46-1.851,13.561,13.561,0,0,1,6.353,1.455,10.318,10.318,0,0,1,4.316,4.138A12.346,12.346,0,0,1,1044.541,566.46Zm-16.552,2.021q0,3.411,2.78,3.411a2.584,2.584,0,0,0,2.214-1.026,6.488,6.488,0,0,0,.922-3.338l.21-3.572a8.851,8.851,0,0,0-1.859-.178,3.992,3.992,0,0,0-3.144,1.261A4.99,4.99,0,0,0,1027.989,568.48Z",
    transform: "translate(-1018.145 -554.676)",
    fill: "#72716f"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSentIcon);
export default __webpack_public_path__ + "static/media/email_sent_icon.3a82ed9224757f0c118526249fa3f98e.svg";
export { ForwardRef as ReactComponent };